module.exports = "/images/amanha.png?e767b99c29d1fde816c83618d9aac65f";